// extracted by mini-css-extract-plugin
export default {"badgeContainer":"WorkspaceAdminEdit_badgeContainer__h3M1A"};